import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
} from '@mui/material';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { useAuth } from './contexts/AuthContext';
import { useBudgetData } from './hooks/useBudgetData';
import { useFileOperations } from './hooks/useFileOperations';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  const { isAuthenticated } = useAuth();
  
  const budgetData = useBudgetData();
  const {
    tabValue,
    orderInfo,
    costBreakdown,
    financialSummary,
    showSuccess,
    showNewPlanDialog,
    handleOrderInfoChange,
    handleCostBreakdownChange,
    handleTabChange,
    handleNewPlan,
    confirmNewPlan,
    handleRefreshLocalStorage,
    setShowSuccess,
    setShowNewPlanDialog,
  } = budgetData;

  const fileOperations = useFileOperations(
    orderInfo,
    costBreakdown,
    financialSummary,
    handleOrderInfoChange,
    handleCostBreakdownChange
  );

  const { fileInputRef, handleImport, handleFileImport, handleExport } = fileOperations;

  // If not authenticated, show login page
  if (!isAuthenticated()) {
    return <LoginPage />;
  }

  return (
    <>
      <DashboardPage
        tabValue={tabValue}
        onTabChange={handleTabChange}
        orderInfo={orderInfo}
        onOrderInfoChange={handleOrderInfoChange}
        costBreakdown={costBreakdown}
        onCostBreakdownChange={handleCostBreakdownChange}
        financialSummary={financialSummary}
        onNewPlan={handleNewPlan}
        onRefresh={handleRefreshLocalStorage}
        onImport={handleImport}
        onExport={handleExport}
        fileInputRef={fileInputRef}
        onFileImport={handleFileImport}
      />

      {/* New Plan Confirmation Dialog */}
      <Dialog open={showNewPlanDialog} onClose={() => setShowNewPlanDialog(false)}>
        <DialogTitle>Create New Plan</DialogTitle>
        <DialogContent>
          Are you sure you want to create a new plan? All current data will be cleared and cannot be recovered.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowNewPlanDialog(false)}>Cancel</Button>
          <Button onClick={confirmNewPlan} color="error" variant="contained">
            Create New Plan
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setShowSuccess(false)} severity="success" sx={{ width: '100%' }}>
          {showNewPlanDialog ? 'New plan created successfully!' : 'Budget saved successfully!'}
        </Alert>
      </Snackbar>
    </>
  );
}

export default function AppWrapper() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}
